/* eslint-disable import/no-webpack-loader-syntax */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import pearDarkBlueUrl from '../../../assets/gems/pear_dark_blue.svg?inline';
export function PearDarkBlue({ ...props }) {
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: pearDarkBlueUrl,
        alt: "PearDarkBlueImage"
    });
}
